import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchIncomeStatementReport = createAsyncThunk(
    'user/fetchIncomeStatementReport',
    async ({user}) => {
        try {
            const incomeReport = await fetchFun(`/api/v1/income-statement?userId=${user?._id}`);
            if(incomeReport?.success) {
                return incomeReport.data
            }
        } catch(error) {
            console.log("Error - /balance-sheet", error)
        }
    }
)